import { types } from 'mobx-state-tree';

const ModelProps = {
  link: types.optional(types.string, ''),
  type: types.maybeNull(types.string),
  outdatedSince: types.maybeNull(types.string),
  lastUpdated: types.maybeNull(types.string),
};

const ContactIntegrations = types
  .model(ModelProps);

export default ContactIntegrations;
